import React, { useEffect, useState } from 'react'
import AdminNavbar from '../Navbar/AdminNavbar';
import axios from 'axios';
import { toast } from 'react-toastify';
import { MdAssignmentTurnedIn } from "react-icons/md";
import { Button, Input, Select, Table } from 'antd';
import '../App.css';
import { Option } from 'antd/es/mentions';
import { AssignMineToUserAdd, AssignMineToUserDelete, AssignMineToUserFindAll, MineMasterFindAllByStatus, StatusUpdateAPI } from '../Api/Transaction_Api';
import { UserMasterGetAll } from '../Api/All_Api';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import TitleNavbar from '../Navbar/TitleNavbar';

const AssignMineToUser = () => {

  const sessionYear = sessionStorage.getItem('sessionYear');
  const year = sessionYear
  const branchId = sessionStorage.getItem('branchId');
const navigate = useNavigate();

    useEffect(() => {
      if (!sessionYear) {
        sessionStorage.clear();
        navigate('/')
      }
    },[])


  const [errors, setErrors] = useState({
    userName: "",
    mineName: "",
  });

  const [pageSize, setPageSize] = useState(10);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);

  const [assignedMineId, setAssignedMineId] = useState("");
  const [userName, setUserName] = useState("");
  const [mineName, setMineName] = useState("");
  const [allUser, setAllUser] = useState([]);
  const [allMine, setAllMine] = useState([]);
  const [allAssignMineToUser, setAllAssignMineToUser] = useState([]);
  // const [updateButton, setUpdateButton] = useState(false);
  // const [saveButton, setSaveButton] = useState(true);

    //======Search data from table===============
    const handleSearch = (value) => {
      const filtered = allAssignMineToUser.filter((item) =>
        Object.values(item).some((val) =>
          val !== null && val !== undefined && val.toString().toLowerCase().includes(value.toLowerCase())
        )
      );
      setFilteredData(filtered);
      setTotalEntries(filtered.length); // Update total entries count after filtering
      setCurrentPage(1);
    };
    //==========Pagination=======================
    const handlePageSizeChange = (value) => {
      setPageSize(value);
    };

  // Fetch Cast Names
  let isUserFetched = false;
  useEffect(() => {
    if (isUserFetched) return;
    fetchUserNames();
    fetchMineNames();
    fetchAssignMineToUser();
    isUserFetched = true;
  }, []);

  const fetchUserNames = async () => {
  
    try {
      const response = await axios.get(`${UserMasterGetAll}?bid=${branchId}`);
      if (response.data !== null) {
        setAllUser(response.data);
      }
    } catch (error) {
      if (!isError) {
        console.error("Error fetching Users:", error);
        toast.error("Failed to fetch Users data");
        isError = true; // Set the flag to prevent double toast
      }
    }
  };

  const fetchMineNames = async () => {
  
    try {
      const response = await axios.get(`${MineMasterFindAllByStatus}?branchId=${branchId}`);
      if (response.data !== null) {
        setAllMine(response.data);
      }
    } catch (error) {
      if (!isError) {
        console.error("Error fetching Mines:", error);
        toast.error("Failed to fetch Mines data");
        isError = true; // Set the flag to prevent double toast
      }
    }
  };


  // ==============Get table data================

  let isError = false;

  const fetchAssignMineToUser = async () => {
 
    try {
      const response = await axios.get(`${AssignMineToUserFindAll}?branchId=${branchId}&accYear=${year}`);
      if (response.data !== null) {
        setAllAssignMineToUser(response.data);
        setFilteredData(response.data); // Set initial filtered data as the fetched data
        setTotalEntries(response.data.length); // Set the total number of entries
      }
    } catch (error) {
      if (!isError) {
        // Check if the error has already been triggered
        console.error("Error fetching Assigned Mines to Users:", error);
        toast.error("Failed to fetch Assigned Mines to Users data");
        isError = true; // Set the flag to prevent double toast
      }
    }
  };

  const columns = [
    {
      title: "Sr.No.",
      dataIndex: "",
      key: "index",
      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: "User Name",
      dataIndex: "userName",
      key: "userName",
    },
    {
      title: "Mine Name",
      dataIndex: "mineName",
      key: "mineName",
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <div>
          <span
            type="submit"
            id={`print-tooltip-${record.id}`}
            style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
            onClick={() => handleDeleteData(record)}
          >
            <i class="fa-solid fa-trash"></i>
          </span>
          <Tooltip
          anchorId={`print-tooltip-${record.id}`}
          content="Delete"
          place="top"
        />
        </div>
      ),
    },
  ];

  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: "#000",
            color: "#fff",
            padding: "10px",
            fontSize: "13px",
            borderRadius: "0px",
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: "#f0f7fd",
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: "8px",
          }}
        >
          {children}
        </td>
      ),
    },
  };

  // ========Cancel data save==================
  const handleCancel = () => {
    setUserName("");
    setMineName("");
    setErrors("");
    fetchAssignMineToUser();
  };

  // ========Submit data to table==============
  // const handleSubmit = async () => {
  //   let isValid = true;
  //   const errorObj = {};

  //   if (!userName.trim()) {
  //     isValid = false;
  //     errorObj.userName = "User Name is required *";
  //   }
  //   if (!mineName) {
  //     isValid = false;
  //     errorObj.mineName = "Mine Name is required *";
  //   }

  //   setErrors(errorObj); // Set error messages

  //   if (!isValid) return;

  //   const bodyData = {
  //     userId: userName,
  //     mineId: mineName,
  //     createdBy: 1,
  //   };

  //   try {
  //     const response = await axios.post(AssignMineToUserAdd, bodyData);

  //     if (response.data === "CREATED") {
  //       toast.success("Mine Assigned Successfully!");
  //       fetchAssignMineToUser();
  //       handleCancel();
  //     } else if (response.data === "ALREADYEXISTS") {
  //       toast.warn("Mine Already Assigned!");
  //       handleCancel();
  //     }
  //   } catch (error) {
  //     console.error("Error during API call:", error);
  //     toast.error("Error occurred while submitting data");
  //   }
  // };

  const handleSubmit = async () => {
    let isValid = true;
    const errorObj = {};
  
    if (!userName) {
      isValid = false;
      errorObj.userName = "User Name is required *";
    }
    if (!mineName) {
      isValid = false;
      errorObj.mineName = "Mine Name is required *";
    }
  
    setErrors(errorObj); // Set error messages
  
    if (!isValid) return;
  
    const bodyData = {
      userId: userName,
      mineId: mineName,
      accYear:parseInt(year),
      branchId:parseInt(branchId),
    };
  
    try {
      const response = await axios.post(AssignMineToUserAdd, bodyData);
  
      if (response.data === "SAVED") {
        toast.success("Mine Assigned Successfully!");
        fetchAssignMineToUser();
        handleCancel();
  
        // Call the second API and pass the status
        const statusData = {
          id: mineName,
          isAssigned:1, 
        };
  
        try {
          const statusResponse = await axios.put(StatusUpdateAPI, statusData);
          if (statusResponse.data == "ASSIGNED") {
            fetchMineNames();
          } else {
            toast.warn("Failed to update status.");
          }
        } catch (statusError) {
          console.error("Error during status API call:", statusError);
          toast.error("Error occurred while updating status.");
        }
  
      } else if (response.data === "ALREADYEXISTS") {
        toast.warn("Mine Already Assigned!");
        handleCancel();
      }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error("Error occurred while submitting data");
    }
  };

  // ========Update data from table============
  // const handleEditDataButton = (item) => {
  //   setUpdateButton(true);
  //   setSaveButton(false);
  //   window.scrollTo(0, 0);
  //   setUserName(item.userId);
  //   setMineName(item.mineId); 
  //   setAssignedMineId(item.id);
  // };

  // const handleUpdate = async () => {
  //   let isValid = true;
  //   const errorObj = {};

  //   if (!userName) {
  //     isValid = false;
  //     errorObj.userName = "User Name is required *";
  //   }
  //   if (!mineName) {
  //     isValid = false;
  //     errorObj.mineName = "Mine Name is required *";
  //   }

  //   setErrors(errorObj); // Set error messages

  //   if (!isValid) return;

  //   const bodyData = {
  //     id: assignedMineId,
  //     userId: userName,
  //     mineId: mineName,
  //   };

  //   try {
  //     const response = await axios.put(AssignMineToUserUpdate, bodyData);

  //     if (response.data === "UPDATED") {
  //       toast.success("Mine Assigned Updated!");
  //       fetchAssignMineToUser();
  //       handleCancel();
  //     } else if (response.data === "ALREADYEXISTS") {
  //       toast.warn("Mine Already Assigned!");
  //       handleCancel();
  //     }
  //   } catch (error) {
  //     console.error("Error during API call:", error);
  //     toast.error("Error occurred while updating data");
  //   }
  // };

  const handleDeleteData = async (item) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete the Assigned Mine "${item.mineName}"?`
    );
    if (!confirmDelete) return;

    try {
      const response = await axios.delete(
        `${AssignMineToUserDelete}?id=${item.id}`
      );
      if (response.data === "DELETED") {
        toast.success("Assigned mine deleted !");
        fetchAssignMineToUser();
         // Call the second API and pass the status
         const statusData = {
          id: item.mineId,
          isAssigned:0, 
        };
  
        try {
          const statusResponse = await axios.put(StatusUpdateAPI, statusData);
          if (statusResponse.data == "ASSIGNED") {
            fetchMineNames();
          } else {
            toast.warn("Failed to update status.");
          }
        } catch (statusError) {
          console.error("Error during status API call:", statusError);
          toast.error("Error occurred while updating status.");
        }

      }
    } catch (error) {
      console.error("Error during delete operation:", error);
      toast.error("Error occurred while deleting the Assigned Mine");
    }
  };

//===================================
const navbg = {
  backgroundColor:"#f79400",
  boxShadow: "0 2px 4px -2px rgba(0,0,0,.5)",
  display: "flex",
  alignItems: "center",
  padding: "5px 10px",
  fontSize: "19px",
  color:"#fff"
}
//=====================================================

  return (
    <>
      <AdminNavbar />

    <div className="p-0 m-0">
        <div
          className="row m-0"
          style={navbg}
        >
          <div
            className="col-12 "
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
            }}
          >
             <span className="px-md-5" style={{ flexGrow: 1}}>
             {" "}
        <MdAssignmentTurnedIn /> &nbsp; Assign Mine To User
      </span>

      {/* TitleNavbar stays on the left without extra margin */}
      <span>
        <TitleNavbar />
      </span>
          </div>

  
        </div>

        <div className='row m-0 p-0 pt-5'>
          <div className='col-12 col-md-2 col-lg-4'></div>
          <div className='col-12 col-md-8 col-lg-4'>
              <div className="row px-md-5 mt-3  m-0">

                <div className="col-12 pt-2">
                  <div className="row m-0">
                    <div className="col-3 p-0 lableStyle">
                      <label className="labels">User :</label>
                    </div>
                    <div className="col-9">
                      <Select
                        value={userName || undefined}
                        onChange={setUserName}
                        showSearch
                        className="w-100"
                        placeholder="Select User"
                        optionFilterProp="children"
                      >
                        {allUser.map((user) => (
                          <Option key={user.id} value={user.id}>
                            {user.name}
                          </Option>
                        ))}
                      </Select>
                      {errors.userName && (
                        <div className="errorField">{errors.userName}</div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-12 pt-2">
                  <div className="row m-0">
                    <div className="col-3 p-0 lableStyle">
                      <label className="labels">Mine :</label>
                    </div>
                    <div className="col-9">
                      <Select
                        value={mineName || undefined}
                        onChange={setMineName}
                        showSearch
                        className="w-100"
                        placeholder="Select Mine"
                        optionFilterProp="children"
                      >
                        {allMine.map((mine) => (
                          <Option key={mine.id} value={mine.id}>
                            {mine.mineName}
                          </Option>
                        ))}
                      </Select>
                      {errors.mineName && (
                        <div className="errorField">{errors.mineName}</div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-12 text-center pt-3">
                  <Button
                    type="submit"
                    className="CancelBtn mx-1"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                  {/* {saveButton && ( */}
                  <Button
                    type="submit"
                    className="SubmitBtn mx-1"
                    onClick={handleSubmit}
                  >
                    Save
                  </Button>
                  {/* )} */}
                  {/* {updateButton && (
                    <Button
                      type="submit"
                      className="UpdateBtn mx-1"
                      onClick={handleUpdate}
                    >
                      Update
                    </Button>
                  )} */}
                </div>

                <div
                  className="col-12 p-0 mt-3"
                  style={{ borderBottom: "2px solid #bfb597" }}
                ></div>
              </div>
          </div>
          <div className='col-12 col-md-2 col-lg-4'></div>
        </div>
        {/*================ Table =========================*/}
        <div className="row m-0 p-2 mb-5  pt-md-0 mt-3">
        <div className='col-12 col-md-2'></div>
          <div  className="col-12 col-md-8 py-3 shadow border"
            style={{ marginBottom: "50px", backgroundColor: "white" }}
          >
            <div
              className="col-12 px-md-5"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>
                <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                <Select
                  defaultValue={pageSize}
                  onChange={handlePageSizeChange}
                  style={{ width: 120, textAlign: "center" }}
                >
                  <Option value={10}>10</Option>
                  <Option value={20}>20</Option>
                  <Option value={30}>30</Option>
                </Select>
              </div>

              <div className="pt-4 pt-md-0">
                <Input.Search
                  placeholder="Search"
                  onSearch={handleSearch}
                  style={{ width: 200, marginBottom: 16 }}
                />
              </div>
            </div>

            <div style={{ backgroundColor: "white" }}>
              <Table
                bordered
                style={{ padding: "0px 20px", overflowX: "auto" }}
                columns={columns}
                dataSource={filteredData}
                pagination={{
                  pageSize: pageSize,
                  total: totalEntries,
                  showTotal: (total, range) =>
                    `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                  current: currentPage,
                  onChange: (page) => setCurrentPage(page),
                }}
                showSorterTooltip={false}
                rowKey={(record) => record.id}
                components={components}
              />
            </div>
          </div>
          <div className='col-12 col-md-2'></div>
        </div>
      </div>

    </>
  )
}

export default AssignMineToUser